import { TextLink } from '@edsn/pie-components';
import downloadIcon from '@iconify/icons-material-symbols/download';
import type { IconifyIcon } from '@iconify/react/dist/iconify.js';
import type { PropsWithChildren } from 'react';
import { trpc } from '#pie/trpc';
import { Icon } from '../icon/Icon';

interface Props extends PropsWithChildren {
  title: string;
  iconStart?: IconifyIcon;
}

export const CraftAssetDownload = ({ title, children, iconStart }: Props) => {
  const { data } = trpc.globals.asset.useQuery({
    title,
  });

  return (
    <TextLink
      download
      href={data?.url}
      iconStart={
        iconStart ? <Icon icon={iconStart} /> : <Icon icon={downloadIcon} />
      }
    >
      {children || title}
    </TextLink>
  );
};
